import { useTranslation } from 'react-i18next';
import { Form, Icon, notify, Page } from '@/components';
import { ArticleEditPanel } from '@/views/Articles.Details';
import { Button, Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AddArticleArgs,
  useGetArticleDetailsQuery,
  useUpdateArticleMutation,
} from '@/redux/articles';
import { useCallback } from 'react';

const useId = () => {
  const params = useParams<'id'>();
  return params.id!;
};

export function ArticleEditPage() {
  const { t } = useTranslation();
  const id = useId();
  const title = t('articles.edit');
  const { data: article, isFetching } = useGetArticleDetailsQuery({ id });
  const [update] = useUpdateArticleMutation();
  const push = useNavigate();

  const handleUpdate = useCallback(
    (value: AddArticleArgs) => {
      update({ ...value, id });
      notify.success.t('articles.details.saved');
      push(-1);
    },
    [id, push, update],
  );
  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/admin#articles">{t('articles.title')}</Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="article" />}
          color="#814A93"
          actions={
            <Space size="middle">
              <Button onClick={() => push(-1)}>{t('cancel')}</Button>
              <Form.Submit uid="article-details" type="primary">
                {t('save')}
              </Form.Submit>
            </Space>
          }
        >
          {!isFetching && (
            <ArticleEditPanel
              onSubmit={handleUpdate}
              initialValue={article}
              id={id}
            />
          )}
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
